export default __webpack_public_path__ + "static/media/investorSteveJobs.f5165679.mp3";